import React from "react";

const UserCount = ({ remaining, total }) => (
  <>
    <strong>{Math.max(remaining, 0)}/{total}</strong> users left
  </>
);

export default UserCount;
